import React from "react";

const ReportItemList = ({ data, setYear, activeYear }) => {
  const renderClass = (item) => {
    let _data = activeYear?.half_year;
    let _item = item?.half_year;

    return _item === _data ? "active" : "";
  };

  const uniquePayableHalfYears = data?.data?.[0]?.payables && [
    ...new Map(
      data.data[0].payables.map((item) => [item.half_year, item])
    ).values(),
  ];

  const uniquePaymentsHalfYears = data?.data?.[0]?.payments && [
    ...new Map(
      data.data[0].payments.map((item) => [item.half_year, item])
    ).values(),
  ];

  let allUniqueHalfYears = [...uniquePayableHalfYears || [], ...uniquePaymentsHalfYears || []]

  allUniqueHalfYears = allUniqueHalfYears.filter((obj, index, self) =>
      index === self.findIndex((o) => o.half_year === obj.half_year)
  );


  return (
    <div className="report-item-list">
      <ul>
        {allUniqueHalfYears &&
            allUniqueHalfYears.map((item, i) => (
            <li
              key={i}
              onClick={() => {
                setYear(item)
              }}
              className={renderClass(item)}
            >
              {item.half_year}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ReportItemList;
